const Loading = () => {
    return (
        <div className="loading-component">
            <img src="/assets/images/loading.svg" alt="loading icon" loading="lazy" width="25" height="25"/>
        </div>
    )
}
export default Loading;
